// Copyright 2016 Sorama B.V.

import { HttpResponseMessage } from "aurelia-http-client";
import { ExceptionType } from "datatypes/SoramaExceptionTypes";

export class HttpResponseMessageError extends Error {
    public statusCode: number;
    public exceptionType: ExceptionType;

    constructor(message: string, statusCode?: number, exceptionType?: ExceptionType) {
        super(message);
        this.name = "HttpResponseMessageError";
        this.statusCode = statusCode;
        this.exceptionType = exceptionType;
    }

    public static fromHttpResponseMessage(response: HttpResponseMessage): HttpResponseMessageError {
        let message: string;
        let exceptionType: ExceptionType;

        if (!response.content) {
            // We should first see if this property exists, it shouldn't exist on HttpResponseMessage
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            message = (response as any).message;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            exceptionType = (response as any).exceptionType;
        } else if (response.content.ModelState) {
            // WebApi ModelState errors
            message = "";

            for (const prop in response.content.ModelState) {
                message += response.content.ModelState[prop];
            }
        } else if (response.content.error) {
            // OWIN Authentication errors
            message = response.content.error_description ? response.content.error_description : response.content.error;
        } else {
            // XHR or other WebApi errors
            message = response.content ? response.content.message : response.statusText;
            exceptionType = response.content ? response.content.exceptionType : "";
        }

        // Strip of any http header messages and leave the actual error object
        return new HttpResponseMessageError(message, response.statusCode, exceptionType);
    }
}
